import { render, staticRenderFns } from "./RightBar.vue?vue&type=template&id=52db8840&scoped=true"
import script from "./RightBar.vue?vue&type=script&lang=js"
export * from "./RightBar.vue?vue&type=script&lang=js"
import style0 from "./RightBar.vue?vue&type=style&index=0&id=52db8840&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db8840",
  null
  
)

export default component.exports